<template>
  <div class="case_banner">
    <div>
      <img src="../../assets/case.jpg" />
      <div class="wenan">
        <div class="wen_title">解决方案</div>
        <div class="wen_content">
          以满足客户流程数字化管控+智慧物联场景建设需求为核心 <br />
          帮助制造企业实现供应敏捷化、制造柔性化、产品个性化、决策智能化
        </div>
      </div>
    </div>
  </div>
  <div class="contaier case">
    <div class="inner">
      <div class="content_title">
        <div class="flex title1">
          <div class="flex-item left">
            <span class="line_"></span>
          </div>
          <div class="text">
            <span>解决</span>
            <span class="red">方案</span>
          </div>
          <div class="flex-item right">
            <span class="line_"></span>
          </div>
        </div>
        <div class="title2">CASE</div>
      </div>
      <div class="case_list">
        <div class="casebox" v-for="caseItem in this.cases" :key="caseItem.id">
          <el-carousel
            :interval="5000"
            indicator-position="none"
            arrow="always"
            height="700px"
          >
            <el-carousel-item
              v-for="path in caseItem.paths"
              @click="openDetail(caseItem.id)"
              style="cursor: pointer;text-align: center;"
              :key="path"
            >
              <img :src="path" class="lumimg" />
            </el-carousel-item>
          </el-carousel>
          <el-button
            v-if="this.isZ && caseItem.status == 2"
            type="danger"
            style="
              position: absolute;
              top: 2%;
              right: 5%;
              width: 120px;
              height: 10px;
              z-index: 10;
            "
            @click="deleteCase(caseItem)"
            round
            >空白暂存模板移除</el-button
          >
          <div v-if="caseItem.title || caseItem.content" class="anli">
            <div class="anli_title">
              <span>{{ caseItem.title }}</span>
            </div>
            <div class="anli_content">
              <span> {{ caseItem.description }}</span>
            </div>
          </div>
        </div>
        <el-button
          @click="openDetail('')"
          v-if="this.isZ"
          round
          style="width: 100%; margin-top: 10px; margin-bottom: 10px"
          >添加案例</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import axios from "axios";
export default {
  data() {
    return {
      store: useStore(),
      isZ: false,
      cases: [],
    };
  },
  mounted() {
    const user = this.store.state.userInfo;
    this.isZ = user ? (user.permission ? user.permission == 0 : false) : false;
    this.queryCase();
  },
  methods: {
    openDetail(id) {
      if (id) {
        this.$router.push("/CaseDetailPage?id=" + id);
      } else {
        this.$router.push("/CaseDetailPage");
      }
    },
    deleteCase(caseItem) {
      this.$confirm("是否暂存案例?", "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(() => {
          const caseDto = {
            id: caseItem.id,
            schemeNo: caseItem.schemeNo,
            attachmentId: caseItem.attachmentId,
            path: caseItem.path,
          };
          axios
            .post("/case/delete", caseDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            })
            .then(() => {
              this.queryCase();
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("产品上架失败", error);
            });
        })
        .catch(() => {});
    },
    queryCase() {
      axios
        .get("/case/query", {
          params: { status: this.isZ ? "" : 1 },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            // ElMessage.success("数据获取成功");
            this.cases = response.data.data;
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("数据获取失败：", error);
        });
    },
  },
};
</script>

<style>
.case_banner {
  width: 100%;
  display: flex;
  flex-direction: column; /* 使子元素垂直排列 */
  /* align-items: center; 水平居中 */
  justify-content: center; /* 垂直居中 */
  position: relative; /* 对于绝对定位的文本 */
  height: 470px;
}
.case_banner img {
  width: 100%; /* 或者你希望的宽度 */
  /* height: auto; 保持图片比例 */
  height: 460px;
}
.wenan {
  position: absolute; /* 或者使用相对定位 */
  top: 25%; /* 根据需要调整距离图片顶部的距离 */
  left: 46%; /* 根据需要调整距离图片左侧的距离 */
  /* width: 100%; 与图片宽度相同 */
  color: white; /* 文字颜色 */
  /* text-align: center; 文字居中 */
  z-index: 10; /* 确保文字在图片上方 */
}
.wen_title {
  font-size: 56px;
  font-weight: 1000;
  font-style: oblique;
  letter-spacing: 12px; /*文本间隔 */
  padding-bottom: 30px;
}
.wen_content {
  font-size: 22px;
  letter-spacing: 3px; /*文本间隔 */
}
.content_title {
  margin-bottom: 10px;
}
.case_list {
  width: 100%;
  margin-bottom: 20px;
}
.casebox {
  position: relative;
  width: 100%;
  margin: auto;
  margin-bottom: 30px;
  background: rgba(0, 159, 233, 0.1);
}
.lumimg {
  /* width: 100%; */
  max-width: 100%;
  height: 100%;
}
.anli {
  position: absolute; /* 或者使用相对定位 */
  bottom: 0%; /* 根据需要调整距离图片底部部的距离 */
  left: 0%; /* 根据需要调整距离图片左侧的距离 */
  width: 100%; /* 与图片宽度相同 */
  color: white; /* 文字颜色 */
  z-index: 10; /* 确保文字在图片上方 */
  background: rgba(0, 0, 0, 0.4);
  /* padding-top: 20px; */
  padding-bottom: 15px;
}
.anli_title {
  width: 90%;
  font-size: 36px;
  font-weight: 1000;
  letter-spacing: 8px; /*文本间隔 */
  padding-bottom: 10px;
  margin: auto;
}
.anli_content {
  width: 90%;
  font-size: 18px;
  letter-spacing: 3px; /*文本间隔 */
  margin: auto;
}
</style>
